import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Box, List, ListItem, Stack, Typography, } from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { LiveSectionProps } from "./models";

import { ZPlayFormField } from "commons/fields";
import ZPlayDateTimePicker from "commons/fields/zplay-datetime-picker";
import HelpIcon from '@mui/icons-material/Help';


export class LiveSection extends React.Component<LiveSectionProps & UseFormReturn, {}> {

  render(){
    return(<>
      <Typography
          color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
          variant="h3"
          textAlign="center"
          mb={1}>
              <Trans id={"df-live-section"}>Setup diretta</Trans>
      </Typography>
      
      <List>
          <ListItem
          disableGutters
          secondaryAction={
              <Stack direction="row" spacing={3}>
                  <Box sx={{ maxWidth: "100px" }}>
                      <ZPlayFormField
                          label={t({
                              id: "df-hours",
                              message: "ore"
                          })}
                          name={`${this.props.name}.hours`}
                          required={true}
                          minValue={0}
                          type={"number"}
                          control={this.props.control}
                          formState={this.props.formState}
                          trigger={this.props.trigger}
                      />
                  </Box>
                  <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR} variant="h2" pt={1}>:</Typography>
                  <Box sx={{ maxWidth: "100px" }}>
                      <ZPlayFormField
                          label={t({
                              id: "df-minutes",
                              message: "minuti"
                          })}
                          name={`${this.props.name}.minutes`}
                          type={"number"}
                          required={true}
                          minValue={0}
                          control={this.props.control}
                          formState={this.props.formState}
                          trigger={this.props.trigger}
                      />
                  </Box>
              </Stack>
          }>
              <Box sx={{ width: "300px" }}>
                  <ZPlayDateTimePicker
                    name={`${this.props.name}.eventStartDateTime`}
                    label={t({
                        id: "df-event-date",
                        message: "Data inizio evento",
                    })}
                    formState={this.props.formState}
                    control={this.props.control}
                    trigger={this.props.trigger}
                  />
              </Box>
              {/*<ZPlayDateTimePicker
                  name="eventEndDateTime"
                  label={t({
                      id: "df-event-end-date",
                      message: "Data fine evento",
                  })}
                  formState={this.props.formState}
                  control={this.props.control}
                  trigger={this.props.trigger}
              />*/}
          </ListItem>
      </List>

      <Stack direction="row" spacing={1} mt={1}>
          <HelpIcon fontSize="small" sx={{color: process.env.REACT_APP_SECONDARY_TEXT_COLOR}}/>
          <Typography
              variant={"body2"}
              color={process.env.REACT_APP_SECONDARY_TEXT_COLOR}>
                  <Trans id={"df-live-section-explanation"}> Inserisci la data di inizio evento e la durata della diretta </Trans>
          </Typography>
      </Stack>
    </>)
  }
}